//
//
//
//

import sticky from './sticky'

export default {
  mounted () {
    this.$nextTick(() => {
      sticky(this.$el)
    })
  }
}



// WEBPACK FOOTER //
// ./~/.2.0.17@vux/src/components/sticky/index.vue